<style lang="scss" scoped>
  .el-header {
    background-color: #264f78;
    //   display: flex;
    padding: 0 0 0 190px;
    // padding: 0;
    height: 70px !important;
    min-width: 1200px;

    .toolTip_box_modal {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .5);
      overflow: hidden;
      z-index: 1000;

      .toolTip_item {
        background-color: #fff;
        text-align: center;
        font-family: '微软雅黑';
        width: 550px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .content_item {
          padding: 40px 90px 35px 90px;
          color: #666;
          font-size: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: 25px;

          .button_item {
            width: 120px;
            margin: 30px auto 0;
            display: block;
            border-radius: 5px;
            cursor: pointer;
            height: 35px;
            line-height: 35px;
            text-align: center;
            color: #fff;
            background-color: #3198FF;
          }
        }
      }
    }
  }

  .contents {
    display: flex;
    // max-width: 1200px;
    height: 100%;
    // margin: 0 auto;
  }

  .centerTop {
    position: relative;
    display: flex;
    flex: 1;
    justify-content: center;
    background-color: #264f78;
    color: white;
    // text-align: center;
    span {
      // line-height: 100%;
      // height: 100%;
      align-self: center;
    }

    .examCenter {
    }

    .examInfo, .checkQuestion {
      position: absolute;
      left: 40px;
      font-size: 18px;
      font-weight: 600;

      &:hover {
        cursor: pointer;
      }
    }

    .checkQuestion {
      left: 130px;
    }

    .examRemainTime {
      position: absolute;
      right: 100px;
    }
  }

  .leftTop {
    display: flex;
    // button {
    //   align-self: center;
    // }
    position: absolute;
    left: 0;
    width: 190px;

    .submitAnswer {
      width: 100%;
      background-color: #ffc831;
      height: 70px;
      // line-height: 70px;
      font-size: 26px;
      color: #ad6012;
      font-weight: 600;
      border-radius: unset;
      border: none;

      &:hover {
        cursor: pointer;
      }
    }

    span {
      align-self: center;
    }
  }

  .examTitle {
    color: white;
    font-weight: 600;
    margin-right: 30px;
    font-size: 26px;
    font-weight: 600;
  }

  .examStatus {
    // border: 1px solid orange;
    // color: orange;
    background-color: #fe6868;
    border-radius: 5px;
    padding: 5px;
    margin-right: 30px;
  }

  .examRemainTime {
    color: white;
  }

  .isMineCraft.el-header {
    padding: 0;
  }

  .goback {
    cursor: pointer;
  }
</style>
<template>
  <el-header :class="{isMineCraft: isMc}">
    <!-- <slot name="headerContent"></slot> -->
    <div v-if="myExam.is_hand" :class="{contents:true}">
      <div class="centerTop">
        <span class="examTitle">查看成绩</span>
        <span class="goback examRemainTime" @click="goBack">返回</span>
      </div>
    </div>
    <div :class="{contents:true}" v-else>
      <div class="leftTop">
        <!-- <el-button type="info">交卷</el-button> -->
        <el-button type="info" v-if="!isMc" @click="handleSubmitAll" class="submitAnswer"
                   :loading="loadinNavBtn">交卷
        </el-button>
        <!-- <el-button type="info">考试须知</el-button> -->
      </div>
      <div class="centerTop">
        <!-- <span @click="handleOpenExamTips" class="examInfo">考试须知</span> -->
        <span v-if="isMc && electron" @click="handleStartMC" class="examInfo">启动MC</span>
        <span v-if="isMc" @click="checkQuestion" class="checkQuestion">查看题干</span>

        <!-- <span class="examCenter"> -->
        <span class="examTitle">{{typeHash === '#normal' ? '编玩边学在线考试平台' : ' 蓝桥杯在线考试平台'}}</span>

        <span class="examStatus">考试进行中</span>
        <!-- </span> -->
        <span class="examRemainTime">{{examTimeLeft}}</span>
      </div>
    </div>

    <div class="toolTip_box_modal" v-show="tips_talg">
      <div class="toolTip_item">
        <div class="content_item">
          <span>考试前60分钟禁止交卷，开考后45分钟时系统自动提交选择题答案并开放操作题，请认真作答！</span>
          <span class="button_item" @click="tipsBtn">我知道了</span>
        </div>
      </div>
    </div>

    <!-- <base-pdf @finish-read-tips="handleFinishRead" :dialogVisible.sync="pdfVisible" :pdfSrc="pdfSrc"></base-pdf> -->

  </el-header>
</template>
<script>
  import eventBus from '@/utils/event.js';
  import {mapMutations, mapState, mapActions} from 'vuex';
  import BasePdf from '@/components/BasePdf.vue';
  import Deliver from '../mixins/eventDeliver';
  import {
    SUBMITCONFIRM, EXAMPAPER, AUTHORITY, MYEXAM,
  } from '@/store/types';
  import {
    postSwitchScreen,
  } from '@/services/getData';

  export default {
    name: 'BaseNav',
    data() {
      return {
        loadinNavBtn: false,
        pdfVisible: false,
        isMock: this.$route.path.match(/^\/mock(E|e)xam/) || this.$route.query.mock === '1',
        isMc: this.$route.path.match(/^\/mine(c|C)raft/),
        electron: null,
        typeHash: sessionStorage.getItem('hash') || this.$route.hash,
        tips_talg: false,
      };
    },
    methods: {
      ...mapMutations({
        setSubmitConfirm: SUBMITCONFIRM,
        setAuthority: AUTHORITY,
      }),
      ...mapActions({
        disMyExam: MYEXAM,
        disExamPaper: EXAMPAPER,
      }),
      goBack() {
        history.go(-1);
      },
      handleSubmitAll() {
        if (this.$route.query.type != 'simulation') {
          let data = this.examPaper;
          if (Object.keys(data).length > 0) {
            let start = this.$moment(data.start_at).format('YYYY-MM-DD HH:mm:ss');
            let start_60 = this.$moment(data.start_at).add(1, 'h').format('YYYY-MM-DD HH:mm:ss');
            let now_time = this.$moment().format('YYYY-MM-DD HH:mm:ss');
            if (data.is_stema == 1) {
              if (now_time > start && now_time < start_60) {
                this.tips_talg = true;
              }

              if (now_time >= start_60) {
                this.loadinNavBtn = true;
                this.setSubmitConfirm(true);
                this.tips_talg = false;
              }
            } else {
              this.loadinNavBtn = true;
              this.setSubmitConfirm(true);
              this.tips_talg = false;
            }
            console.log('当前时间：', now_time);
            console.log('考试开始时间：', start);
            console.log('考试开始60分钟之后时间：', start_60);
          }
        } else {
          this.loadinNavBtn = true;
          this.setSubmitConfirm(true);
          this.tips_talg = false;
        }
      },
      // 关闭交卷的提示弹窗
      tipsBtn() {
        this.tips_talg = false;
      },

      handleOpenExamTips() {
        this.pdfVisible = true;
      },
      checkQuestion() {
        // this.questionVisible = true;
        this.deliverVia('HomeComponent', 'ExamMineCraft', 'show-question', 'params');
      },
      handleStartMC() {
        try {
          if (this.electron) {
            this.electron.ipcRenderer.send('startGame');
          }
        } catch (e) {
          console.log(e);
        }
      },
      handleFinishRead() {
        console.log('postSwitchScreen');
        postSwitchScreen(this.examinee.examination_examinee_id, {
          category: 4,
          remark: '已阅读',
        }).then((result) => {
          this.$message.success('已阅读考试须知');
        }).catch((err) => {
          console.log(err);
        });
      },
    },
    components: {
      BasePdf,
    },
    mixins: [Deliver],
    created() {
      // console.log(this.myExam,'mmmmmmmmmm');
      eventBus.$on('changeStatus', (data) => {
        if (data) {
          // console.log(data,'hello000000');
          this.loadinNavBtn = true;
        } else {
          // console.log(data,'hello111111');
          this.loadinNavBtn = false;
        }
      });
      if (!this.authority) {
        const ls = localStorage.getItem('authority');
        this.setAuthority(JSON.parse(ls));
      }
      if (!this.myExam || JSON.stringify(this.myExam) === '{}') {
        // console.log('disss');
        this.disMyExam(this.authority.admissionTicket);
      }
      if (!this.examPaper || JSON.stringify(this.examPaper) === '{}') {
        // console.log('disss');
        this.disExamPaper(this.authority.admissionTicket);
      }

      try {
        // eslint-disable-next-line
        const electron = eval('require("electron")');
        if (electron) {
          this.electron = electron;
        }
      } catch (e) {
        console.log('electron not supported');
      }
    },
    mounted() {
    },
    props: {
      status: {
        type: String,
      },
    },
    computed: {
      ...mapState({
        authority: 'authority',
        examinee: 'examinee',
        examTimeLeft: 'examTimeLeft',
        myExam: 'myExam',
        submitConfirm: 'submitConfirm',
        serverTime: 'serverTime',
        examPaper: 'examPaper',
      }),
      pdfSrc() {
        const src = this.myExam.exam_file_url;
        return src;
      },
    },
    watch: {
      // submitConfirm(val) {
      //   if (val) {
      //     this.handleSubmitAll();
      //     this.setSubmitConfirm(false);
      //   }
      // },
    },
  };
</script>
